import { xTickStore } from '../../../ng-services/xtick.store';
import { SignalInterface } from '../../../ng-services/social-trading/signal-sharing.store';
import { ChartMarkerInterface } from '../../chart/candlestick-chart.component';

export class SignalSharingTableRowDetailsComponent {
    signal!: SignalInterface;

    get dayPrice() {
        return xTickStore.getPriceChange(this.signal.symbol, 'day');
    }

    get weekPrice() {
        return xTickStore.getPriceChange(this.signal.symbol, 'week');
    }

    get monthPrice() {
        return xTickStore.getPriceChange(this.signal.symbol, 'month');
    }

    get currentPrice() {
        return xTickStore.price.get(this.signal.symbol) || '';
    }

    get history() {
        return xTickStore.getHistory(this.signal.symbol);
    }

    get seasonal_potential() {
        return this.signal.seasonal_potential ?? '--';
    }

    get seasonal_potential_range_upper() {
        return this.signal.seasonal_potential_range_upper ?? '--';
    }

    get seasonal_potential_range_lower() {
        return this.signal.seasonal_potential_range_lower ?? '--';
    }

    get seasonal_potential_probability() {
        return this.signal.seasonal_potential_probability ?? '--';
    }

    getPostUrl() {
        const signal = this.signal;
        if (signal.posts.length === 0) {
            return '';
        }
        return `/post/${signal.posts[0].id}`;
    }

    getSymbolSearchUrl() {
        return `/search?q=${encodeURIComponent('#') + this.signal.symbol}#post`;
    }
}

angular.module('tradersyard').component('tySignalSharingTableRowDetailsComponent', {
    // language=HTML
    template: `
        <div class="row" mobx-autorun>
            <div class="col-md-4 col-sm-12">
                <div class="row">
                    <div class="col-sm-12" ng-if="$ctrl.signal.signal_description">
                        <div class="panel panel-default description_panel">
                            <div class="panel-heading">
                                <h3 class="panel-title">{{$ctrl.signal.signal_name}}</h3>
                            </div>
                            <div class="panel-body">
                                <p>{{$ctrl.signal.signal_description}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="seasonal_potential panel panel-default">
                            <div class="panel-heading">
                                <h3 class="panel-title">Seasonal Potential</h3>
                            </div>
                            <div class="panel-body">
                                <table class="table">
                                    <tbody>
                                    <tr>
                                        <th>Potential (%)</th>
                                        <td>{{$ctrl.seasonal_potential}}</td>
                                    </tr>
                                    <tr>
                                        <th>Upper range</th>
                                        <td>{{$ctrl.seasonal_potential_range_upper}}</td>
                                    </tr>
                                    <tr>
                                        <th>Lower range</th>
                                        <td>{{$ctrl.seasonal_potential_range_lower}}</td>
                                    </tr>
                                    <tr>
                                        <th>Probability (%)</th>
                                        <td>{{$ctrl.seasonal_potential_probability}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" style="margin-bottom: 10px">
                        <div class="btn-group btn-group-justified">
                            <a ng-href="{{$ctrl.getSymbolSearchUrl()}}" class="btn btn-info"><i class="fa fa-comment"></i> See discussions on #{{$ctrl.signal.symbol}}</a>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="btn-group btn-group-justified">
                            <a ng-href="{{$ctrl.getPostUrl()}}" class="btn btn-info"><i class="fa fa-comment"></i> See discussion on this signal</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 signal_sharing_table_row_details__details_table">
                <table class="table">
                    <tbody>
                    <tr>
                        <th>Price</th>
                        <td>{{$ctrl.currentPrice}}</td>
                    </tr>
                    <tr>
                        <th>1 Day</th>
                        <td>{{$ctrl.dayPrice}}</td>
                    </tr>
                    <tr>
                        <th>7 Days</th>
                        <td>{{$ctrl.weekPrice}}</td>
                    </tr>
                    <tr>
                        <th>30 Days</th>
                        <td>{{$ctrl.monthPrice}}</td>
                    </tr>
                    <tr>
                        <th>Date</th>
                        <td>{{$ctrl.signal.created_at|moment:'L LT'}}</td>
                    </tr>
                    <tr ng-if="$ctrl.signal.groups.length">
                        <th>Groups</th>
                        <td>
                            <ul ng-repeat="group in $ctrl.signal.groups">
                            <li><a ng-href="/group/{{group.id}}">{{group.name}}</a></li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th>Trader</th>
                        <td>
                            <a ng-href="{{$ctrl.signal.user.id}}" ng-if="$ctrl.signal.user">{{$ctrl.signal.user.name}}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-sm-12 col-md-8">
                <ty-signal-sharing-candlestick signal="$ctrl.signal"/>
            </div>
        </div>
    `,
    controller: SignalSharingTableRowDetailsComponent,
    bindings: {
        signal: '<',
    },
});
